import { get } from 'lodash';
import { converter } from '../../../helpers/converter';
import * as constants from '../../../constants';
import Utils from '../../../utils/Utils';
import ClaroUrlBuilder from '../../../utils/ClaroUrlBuilder';

export const isUserAnonymous = userType =>
  userType === constants.ANONYMOUS_USER;
export const canIDownloadEpisodes = (metadata, types) => {
  const { downloadable_format_types: formatTypes = '' } = metadata;

  let data;
  if (typeof types === 'undefined' || types.length === 0) {
    return false;
  }

  try {
    data = JSON.parse(formatTypes);

    if (typeof data[constants.GetRegion()] === 'undefined') {
      data = data.default;
    } else {
      data = data[constants.GetRegion()];
    }

    for (let i = 0; i < data.format_types.length; i += 1) {
      if (types.indexOf(data.format_types[i]) > -1) {
        return true;
      }
    }

    return false;
  } catch (e) {
    return false;
  }
};
export const canIUpdateData = (props, nextProps) =>
  props.params.id !== nextProps.params.id;

export const canIGetRecommendations = (props, nextProps) =>
  nextProps.metadata !== props.metadata ||
  props.params.id !== nextProps.params.id;

export const canIGetBookmarks = (props, nextProps) =>
  typeof nextProps.user.userhash !== 'undefined' &&
  props.data.seasons.length === 0 &&
  nextProps.data.seasons.length > 0;
export const canISeeModalOrRedirect = (props, nextProps) =>
  typeof nextProps.episodeSelected.groupId !== 'undefined' &&
  nextProps.episodeSelected.groupId !== props.episodeSelected.groupId;
export const getLocalLanguage = () =>
  constants.GetRegion() === 'brasil' ? 'pt_BR' : 'es_ES';

export const getUrlToShare = () =>
  `https://www.clarovideo.com${window.location.pathname}?sharemeta=true`;
export const getUrlToSearchPerson = (id, fullName) =>
  `/${constants.GetRegion()}/search?q=${encodeURIComponent(
    fullName,
  )}&type=talent&id=${id}`;
export const getBookmarksIndexed = data => {
  let bookmarks = {};
  data.forEach(item => {
    const bm = {};

    bm[item.id] = {
      id: item.id,
      viewed: item.vistime.viewed === 'true',
      progress: getProgress(item.vistime),
    };

    bookmarks = { ...bookmarks, ...bm };
  });
  return bookmarks;
};
export const getCollaborators = (extendedcommon = {}, labels) => {
  const genres = {
    label: converter.convertApaUnicode(labels, 'genre', 'Géneros'),
    values: [],
  };
  const arrayGenres = get(extendedcommon, 'genres.genre', []);
  const arrayRoles = get(extendedcommon, 'roles.role', []);

  genres.values = arrayGenres.map(genere => ({
    name: genere.desc,
  }));

  const talents = [];

  arrayRoles.forEach(role => {
    const t = get(role, 'talents.talent', []);
    const values = t
      .filter(talent => talent.name !== 'ND')
      .map(talent => {
        let text = talent.fullname;
        if (talent.surname) {
          text = `${talent.surname}, ${talent.name}`;
        }
        return {
          name: text,
          id: talent.id,
        };
      });

    talents.push({
      label: role.desc,
      values,
    });
  });
  return [genres, ...talents];
};
export const getSeasons = (seasons, labels, bookmarks) => {
  if (seasons === null) {
    return [];
  }

  return seasons.map((season, i) => ({
    id: season.id,
    title: `${labels.season} ${season.number}`,
    number: season.number,
    chapters: season.episodes.map(episode => ({
      id: episode.id,
      title: `${labels.episode} ${episode.episode_number}: ${
        episode.title_episode
      }`,
      url: '/',
      seasonNumber: episode.season_number,
      titleUri: episode.title_uri,
      isProgressStarted: bookmarks[episode.id] && bookmarks[episode.id].viewed,
      progressPercentage:
        bookmarks[episode.id] && bookmarks[episode.id].progress,
    })),
  }));
};
export const getTimeFormat = time => {
  if (typeof time !== 'string') {
    return '';
  }
  const resultTime = [];
  const timeChunk = time.split(':');

  if (timeChunk[0] != '00') {
    resultTime.push(`${timeChunk[0]}h `);
  }
  resultTime.push(`${timeChunk[1]}min `);
  resultTime.push(`${timeChunk[2]}s`);
  return resultTime.join(' ');
};
export const getLinkEpisode = ({ nodeId, title, episodeId }) =>
  `/${constants.GetRegion()}/vcard/${nodeId}/${title}/${episodeId}`;
export const getLanguages = (languages = []) =>
  languages.map(language => {
    const {
      content_id: id,
      label_large: text,
      option_id: dubsub,
      option_id: optionId,
      encodes,
    } = language;
    return { id, text, dubsub, optionId, encodes };
  });

export const addConfigLocal = data => {
  let configDownloads = localStorage.getItem('configDownloads');
  try {
    configDownloads = JSON.parse(configDownloads);
    configDownloads = { ...configDownloads, ...data };
    localStorage.setItem('configDownloads', JSON.stringify(configDownloads));
  } catch (e) {}
};

export const getConfigLocal = () => {
  let configDownloads = localStorage.getItem('configDownloads');
  try {
    configDownloads = JSON.parse(configDownloads);

    if (configDownloads !== null) {
      return configDownloads;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const getLinkPlay = ({ purchaseInfo, data, config, user, params }) => {
  if (!purchaseInfo.isPlayButtonVisible) {
    return;
  }
  let vendor = null;
  if (data.media.proveedorName) {
    vendor = data.media.proveedorName;
  }
  let playable = false;

  if (['AMCO', 'NOGGIN', 'CRACKLE'].indexOf(vendor) === -1) {
    navigator.sayswho = (function() {
      const ua = navigator.userAgent;

      let tem;

      let M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i,
        ) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return ['IE', tem[1] || ''];
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) {
          return tem
            .slice(1)
            .join(' ')
            .replace('OPR', 'Opera')
            .split(' ');
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M;
    })();

    if (
      navigator.sayswho[0] &&
      constants.SUPPORTED_STREAM[navigator.sayswho[0].toLowerCase()]
    ) {
      constants.SUPPORTED_STREAM[navigator.sayswho[0].toLowerCase()].map(
        (stream, index) => {
          data.media.languages.map(aStream => {
            if (
              aStream.encodes.indexOf(stream) > -1 ||
              aStream.encodes.indexOf(`${stream}_ma`) > -1
            ) {
              playable = stream;
            }
          });
        },
      );
    }

    // WPLAY-4920
    if (
      navigator.sayswho[0].toLowerCase() === 'safari' &&
      data.media.proveedorCode === 'foxv3'
    ) {
      // || data.media.proveedorCode === "hbo")){
      playable = 'hlsfps_ma';
    }

    if (playable === false) {
      return 'ErrorSimple';
    }
  }

  const isMobile = Utils.MobileCheck();

  if (isMobile) {
    return `/${user.region}/devices?runplayerinapp&group_id=${params.id}`;
  }
  if (purchaseInfo === null && data === null) {
    return;
  }

  const nodeId = params.nodeId ? params.nodeId : 'home';

  let urlPlayer = ClaroUrlBuilder.player(params.id);
  if (playable !== false) {
    urlPlayer += `&streamF=${playable}`;
  }

  if (data && data.canPlay) {
    window.location = urlPlayer;
  }

  if (purchaseInfo && purchaseInfo.canPlay) {
    window.location = urlPlayer;
  }

  if (
    purchaseInfo.playButton.waspurchased === '1' &&
    data.media.isLiveEnabled === '0'
  ) {
    window.location = urlPlayer;
  }

  if (data.media.isLivePPE) {
    const pId = purchaseInfo.playButton.purchaseid;
    const ofId = purchaseInfo.playButton.offerid;
    urlPlayer += `&purchaseid=${pId}&offerid=${ofId}&isliveppe=true`;

    window.location = urlPlayer;
  }
};

export const getNodesEpisodes = (seasons = []) => {
  const nodes = [];
  seasons.map(season => season.chapters.map(chapter => nodes.push(chapter.id)));
  return nodes;
};

export const getConfigPriority = ({
  languages,
  options = ['D-ES', 'S-ES'],
}) => {
  for (let i = 0; i < options.length; i += 1) {
    const index = languages.findIndex(l => l.dubsub === options[i]);
    if (index !== -1) {
      return {
        dubsub: languages[index].dubsub,
        contentId: languages[index].id,
      };
    }
  }
  return null;
};

export const getUpdatedConfig = ({ downloadConfig, languages }) => {
  if (downloadConfig === null) {
    downloadConfig = {};
  }
  let config = {
    quality: 'sd',
    ...downloadConfig,
  };
  const priority = getConfigPriority({ languages });

  if (typeof config.contentId === 'undefined') {
    config = { ...config, ...priority };
  } else {
    const find = languages.find(l => l.optionId === config.dubsub);
    if (typeof find !== 'undefined') {
      config.contentId = find.id;
    } else {
      config = { ...config, ...priority };
    }
  }

  return config;
};

export const getProgress = vistime => {
  if (vistime.viewed !== 'true') {
    return 0;
  }
  if (vistime.last && vistime.last.progress) {
    return vistime.last.progress;
  }
  if (vistime.max && vistime.max.progress) {
    return vistime.max.progress;
  }
  return 0;
};

export const itHadSeenLast = (paramId, episode) => {
  if (
    episode.seenLast &&
    episode.seenLast.seenLast &&
    episode.seenLast.seenLast.episode &&
    episode.seenLast.seenLast.episode.id
  ) {
    const seenLastId = episode.seenLast.seenLast.episode.id;
    return seenLastId !== paramId;
  }
  return false;
};

export const replaceUserInformation = (msg, userData) => {
  const replacer = (str, p1, p2, p3, offset, s) =>
    userData[p2] || userData[p2.toLowerCase()];
  return msg.replace(/({@)([a-z]*)(})/gi, replacer);
};
